<template>
    <v-col cols="12" sm="6" md="6" lg="8" xl="8">
        <v-card>
            <v-toolbar flat dense color="grey lighten-4">
                <v-toolbar-title>
                    {{ widget.body.title }}
                </v-toolbar-title>
            </v-toolbar>
            <v-divider />
            <v-card-text>
                <v-container class="pa-0 pb-1">
                    <v-row>
                        <v-col class="pa-0 pl-2 pb-1" cols="12" md="5" lg="3">
                            <v-menu
                                v-model="menuFrom"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                            >
                                <template #activator="{on}">
                                    <v-text-field
                                        v-model="filters.checkDate__gte"
                                        label="Od:"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        clearable
                                        outlined
                                        dense
                                        hide-details
                                        :disabled="paperNeededLoading"
                                        v-on="on"
                                    />
                                </template>
                                <v-date-picker
                                    v-model="filters.checkDate__gte"
                                    first-day-of-week="1"
                                    @input="menuFrom = false"
                                />
                            </v-menu>
                        </v-col>
                        <v-col class="pa-0 pl-2 pb-1" cols="12" md="5" lg="3">
                            <v-menu
                                v-model="menuTo"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                            >
                                <template #activator="{on}">
                                    <v-text-field
                                        v-model="filters.checkDate__lte"
                                        label="Do:"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        clearable
                                        outlined
                                        dense
                                        hide-details
                                        :disabled="paperNeededLoading"
                                        v-on="on"
                                    />
                                </template>
                                <v-date-picker
                                    v-model="filters.checkDate__lte"
                                    first-day-of-week="1"
                                    @input="menuTo = false"
                                />
                            </v-menu>
                        </v-col>
                        <v-col class="pa-0 pl-2 pt-1" cols="12" md="1" lg="1">
                            <v-btn
                                fab
                                color="secondary"
                                x-small
                                elevation="1"
                                data-sentry-label="Odśwież"
                                :disabled="paperNeededLoading"
                                @click="changeFilter"
                            >
                                <v-icon color="white">
                                    mdi-refresh
                                </v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
                <v-data-table
                    :headers="headers"
                    :loading="paperNeededLoading"
                    :items="paperNeeded"
                    dense
                    height="275"
                    :footer-props="footerProps"
                    :server-items-length="pagination.itemsLength"
                    :mobile-breakpoint="0"
                    name="paperNeededData"
                    @pagination="updatePagination"
                >
                    <template #item="{item}">
                        <tr>
                            <td>
                                {{ item.checkDate }}
                            </td>
                            <td>
                                {{ item.paper }}
                            </td>
                            <td>
                                {{ item.qtyInSht }}
                            </td>
                            <td>
                                {{ item.qtyInKgs }}
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </v-col>
</template>

<script>
import filters from '@/mixins/dataTableFilters'
import pagination from '@/mixins/dataTablePagination'
import { errorHandler } from '@/utils/errorHandler'

export default {
    name: 'PaperNeeded',
    mixins: [
        filters,
        pagination
    ],
    props: {
        widget: {
            type: Object,
            default: null
        },
        permissions: {
            type: Array,
            default: null
        }
    },
    data() {
        return {
            fromDate: null,
            toDate: null,
            menuFrom: false,
            menuTo: false,
            headers: [
                {
                    text: 'Data zamknięcia zlecenia',
                    value: 'checkDate',
                    sortable: false,
                },
                {
                    text: 'Papier',
                    value: 'paper',
                    sortable: false
                },
                {
                    text: 'Ilość (ark)',
                    value: 'qtyInSht',
                    sortable: false
                },
                {
                    text: 'Ilość (kg)',
                    value: 'qtyInKgs',
                    sortable: false
                },
            ],
        }
    },
    computed: {
        savedFilters() {
            return this.$store.state.dashboard.dashboard.filters
        },
        filterQuery() {
            const filters = Object.assign({}, this.filters)
            let query = ''

            for (let item in filters) {
                if (filters[item] != null && filters[item] != '') {
                    query = query.concat('&', `${item}=${filters[item]}`)
                }
            }

            return query
        },
        paperNeeded() {
            return this.$store.state.dashboard.dashboard.paperNeeded
        },
        paperNeededLoading() {
            return this.$store.state.dashboard.dashboard.paperNeededLoading
        },
    },
    created() {
        this.pagination.itemsPerPage = 10
        this.pagination.page = 1
        this.getDashboard()
    },
    methods: {
        getDashboard() {
            this.$store.dispatch('dashboard/getDashboardItem', {
                item: this.widget,
                paginate: this.paginate(),
                query: this.filterQuery
            })
                .then(response => {
                    this.handlePaginationResponse(response.data.body)
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        changeFilter() {
            this.$store.dispatch('dashboard/setDashboardFilters', this.filters)
                .catch(error => {
                    errorHandler(error)
                })
            this.getDashboard()
        },
        updatePagination(pagination) {
            this.pagination = pagination

            if (pagination.pageCount !== 0 && !this.paginationSettings.paginationPending) {
                this.getDashboard()
            }
            this.clearPaginationPending()
        }
    }
}
</script>
